// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"6ad6da31","139":"4ee5a7d9","146":"1ab8d325","167":"169735ba","216":"e7461855","230":"045bdcb6","453":"eb570f4f","461":"6153ed7d","520":"47655a3d","679":"b2cebbb8","867":"a83b76a5","929":"386d6c91","977":"dedf65ab","978":"d3dce468"}[chunkId] + ".chunk.js";
};